
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { StockTransactionApi } from '../api/stock-transaction.api';
import { switchMap, map } from 'rxjs/operators';
import { StockTransactionData, StockTransaction } from '../../../interfaces/masters/stock-transaction';

@Injectable()
export class StockTransactionService extends StockTransactionData {

  constructor(private api: StockTransactionApi) {
    super();
  }



  list(url: string): Observable<StockTransaction[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<StockTransaction>{
      return this.api.getById(url);
  }

  create(url: string, data:StockTransaction): Observable<StockTransaction> {
    return this.api.add(url,data);
  }

  update(url: string, data:StockTransaction): Observable<StockTransaction> {
    return this.api.update(url,data);
  }
  searchList(url: string,data:any): Observable<any> {
     
    return this.api.searchList(url,data);
  }


  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
